import type { Session } from "@auth/core/types";
import useSWR from "swr";

const fetcher = (url: string) => fetch(url).then(r => r.json())

export function useSession(revalidateOnMount = false) {
    const isSignedIn = getSignedIn() || hasJustSignedIn()

    return useSWR<Session | null>("/api/auth/session", fetcher, {
        revalidateOnMount: isSignedIn ? revalidateOnMount : false,
        revalidateOnFocus: false,
        revalidateOnReconnect: false,
        onSuccess: (session) => setSignedIn(Boolean(session).toString()),
    })
}

function hasJustSignedIn() {
    return typeof window === "undefined" ? false : new URLSearchParams(window.location.search).has("isSignedIn")
}

function setSignedIn(value: string): void {
    try {
        localStorage.setItem("isSignedIn", value)
    } catch (e) {
    }
}

function getSignedIn(): boolean {
    try {
        return localStorage.getItem("isSignedIn") === "true"
    } catch (e) {
        return false
    }
}